import { z } from "zod";

export const DeleteProcessesRequestPathParamSchema = z.object({
  processId: z.string(),
});

export type DeleteProcessesRequestPathParamType = z.infer<
  typeof DeleteProcessesRequestPathParamSchema
>;
